/**
 * Centralized API Endpoints Registry
 * Endpoint paths are encoded to prevent plain text URL extraction from production JS bundles.
 */

const d = (str) =>
  typeof window !== "undefined" && typeof window.atob === "function"
    ? window.atob(str)
    : typeof Buffer !== "undefined"
    ? Buffer.from(str, "base64").toString("binary")
    : str;

// 1. HelloTrade Backend Endpoints (REACT_APP_HELLOTRADE_API_BASE_URL)
export const HT_ENDPOINTS = {
  get ADD_INFO() { return d("L3YxL2FkZEluZm8="); },
  get STAGE_MAPPING() { return d("L3YxL3N0YWdlTWFwcGluZw=="); },
  get GET_CLIENT_DETAILS() { return d("L3YxL2dldENsaWVudERldGFpbHM="); },
  get FETCH_CUSTOMER_DATA() { return d("L3YxL2ZldGNoLWN1c3RvbWVyLWRhdGE="); },
  get UPDATE_BUSINESS_AGE() { return d("L3YxL3VwZGF0ZUJ1c2luZXNzQWdl"); },
  get DOWNLOAD_CSV() { return d("L3YxL2Rvd25sb2FkQ1NW"); },
  get CHECK_CONSENT() { return d("L3YxL2NoZWNrLWNvbnNlbnQ="); },
  get CREATE_CONSENT() { return d("L3YxL2NyZWF0ZS1jb25zZW50"); },
  get UPDATE_LEAD_STAGE() { return d("L3YxL3VwZGF0ZUxlYWRTdGFnZQ=="); },
  PL_CHECK_STATUS: (glid) => `${d("L3YxL3BlcnNvbmFsLWxvYW4vY2hlY2stc3RhdHVzLw==")}${glid}`,
  get PL_CREATE_REFERRAL() { return d("L3YxL3BlcnNvbmFsLWxvYW4vY3JlYXRlLXJlZmVycmFs"); },
  get PL_GENERATE_AUTH_TOKEN() { return d("L3YxL3BlcnNvbmFsLWxvYW4vZ2VuZXJhdGUtYXV0aC10b2tlbg=="); },
  get AA_INIT() { return d("L3YxL2FhL2NvbnNlbnQvaW5pdA=="); },
  get AA_FETCH() { return d("L3YxL2FhL2NvbnNlbnQvZmV0Y2g="); },
  get AA_EVENT() { return d("L3YxL2FhL2NvbnNlbnQvZXZlbnQ="); },
  get GL_PINCODE_SERVICEABILITY() { return d("djEvZ29sZGxvYW4vcGluY29kZS1zZXJ2aWNlYWJpbGl0eQ=="); },
  get GL_SUBMIT_APPLICATION() { return d("djEvZ29sZGxvYW4vc3VibWl0LWFwcGxpY2F0aW9u"); },
  get GL_PROFILE() { return d("djEvZ29sZGxvYW4vcHJvZmlsZQ=="); },
  get GL_CALC() { return d("djEvZ29sZGxvYW4vZ29sZC1wcmljZS9jYWxj"); },
  get GL_STAGE_TO_PAGE_MAPPING() { return d("djEvZ29sZGxvYW4vc3RhZ2UtdG8tcGFnZS1tYXBwaW5n"); },
  get GL_FETCH_REQUIREMENT() { return d("djEvZ29sZGxvYW4vZmV0Y2gtcmVxdWlyZW1lbnQ="); },
  get GL_MUTHOOT_REDIRECT() { return d("djEvZ29sZGxvYW4vbXV0aG9vdC1yZWRpcmVjdC11cmw="); },
  get GEN_OTP() { return d("L3YxL2dlbk9UUA=="); },
  get RESEND_OTP() { return d("L3YxL3Jlc2VuZE9UUA=="); },
  get VALIDATE_OTP_V2() { return d("L3YxL3ZhbGlkYXRlT3RwVjI="); },
  get FETCH_ALL_DETAILS_V2() { return d("L3YxL2ZldGNoQWxsRGV0YWlsc1Yy"); },
  get REFRESH_SELLER_DATA() { return d("L3YxL3JlZnJlc2hTZWxsZXJEYXRh"); },
  get GET_APPROVED_LOAN_AMOUNT() { return d("L3YxL2dldEFwcHJvdmVkTG9hbkFtb3VudA=="); },
  get CAPTURE_APPLY() { return d("L3YxL2NhcHR1cmVBcHBseQ=="); },
  get APPLY_CLICK_V2() { return d("L3YxL2FwcGx5Q2xpY2tWMg=="); },
  get BUREAU_SEND_OTP() { return d("L3YxL2J1cmVhdS1zZW5kLW90cA=="); },
  get BUREAU_VALIDATE_OTP() { return d("L3YxL2J1cmVhdS12YWxpZGF0ZS1vdHA="); },
  get WHATSAPP_OPTIN() { return d("L3YxL3doYXRzYXBwL29wdGlu"); },
  get GET_CREDILIO_URL() { return d("L3YxL2dldENyZWRpbGlvVXJs"); },
  get WRITE_FRONT_LOG() { return d("L2FwaS92MS93cml0ZUh0RnJvbnRMb2c="); },
  get WRITE_LOG_DIRECT() { return d("L2FwaS92MS93cml0ZUhUTG9nRGlyZWN0"); },
  get SAVE_CUSTOMER_DATA() { return d("L3YxL3NhdmUtY3VzdG9tZXItZGF0YQ=="); },
  get POST_CONSENT() { return d("L3YxL3Bvc3RDb25zZW50"); },
  get MARK_INVALID() { return d("L3YxL21hcmtJbnZhbGlk"); },
  get SESSION_PING() { return d("L2FwaS92MS9zZXNzaW9uUGluZw=="); },
  get GET_STATE() { return d("L3YxL2dldFN0YXRl"); },
  get GET_CREDS() { return d("L3YxL2dldENyZWRz"); },
  get GET_LEAD_SUBSTAGE() { return d("L3YxL2dldExlYWRTdWJzdGFnZQ=="); },
  get CREDIT_SCORE() { return d("L3YxL2J1cmVhdS9jcmVkaXRTY29yZQ=="); },
  get GET_APPROVED_LOAN_AMOUNT_V2() { return d("L3YyL2dldEFwcHJvdmVkTG9hbkFtb3VudA=="); },
  get NET_BANKING_INIT() { return d("L3YxL2JhbmtpbmcvbmV0YmFua2luZy9pbml0aWF0ZVNlc3Npb24="); },
  get NET_BANKING_EVENTS() { return d("L3YxL2JhbmtpbmcvbmV0YmFua2luZy9uZXRCYW5raW5nRXZlbnRz"); },
  get DOWNLOAD_PDF() { return d("L2FwaS92MS9kb3dubG9hZFBERg=="); },
};

// 2. Loans Backend Endpoints (REACT_APP_BACKEND_PATH)
export const LOANS_ENDPOINTS = {
  get APPLY_CLICK_V4() { return d("L3YxL2FwcGx5Q2xpY2tWNA=="); },
  get USER_JOURNEY_DECISION() { return d("L3YxL3VzZXJKb3VybmV5RGVjaXNpb24="); },
  get GET_JOURNEY_FLAGS() { return d("L3YxL2dldEpvdXJuZXlGbGFncw=="); },
  get GET_LEAD_SUBSTAGE() { return d("L3YxL2dldExlYWRTdWJzdGFnZQ=="); },
  get APPLY_CLICK_SHEET() { return d("L3YxL2FwcGx5Q2xpY2tTaGVldA=="); },
  get CAPTURE_CLICK() { return d("L3YxL2NhcHR1cmVDbGljaw=="); },
  get GET_DYNAMIC_LOAN_OFFER() { return d("L3YxL2dldER5bmFtaWNMb2FuT2ZmZXI="); },
  get OFFER_CLICK() { return d("L3YxL29mZmVyQ2xpY2s="); },
  get INITIATE_INDIFI_REDIRECT() { return d("L3YxL2luaXRpYXRlSW5kaWZpUmVkaXJlY3Q="); },
  get GET_OWNER_INFO() { return d("L3YxL2dldE93bmVySW5mbw=="); },
  get PL_CHECK_BUREAU() { return d("djEvcGVyc29uYWwtbG9hbi9jaGVjay1idXJlYXU="); },
  get PL_AUTHENTICATE_DELIVERY() { return d("djEvcGVyc29uYWwtbG9hbi9hdXRoZW50aWNhdGUtZGVsaXZlcnk="); },
  get GET_BUREAU_NS_JOURNEY() { return d("L3YxL2dldEJ1cmVhdU5TSm91cm5leQ=="); },
  get SET_LOGS() { return d("L3YxL3NldExvZ3M="); },
  get MARK_HT_LAND() { return d("L3YxL21hcmtIVExhbmQ="); },
  get SEND_STAGE_AUDIT_EVENT() { return d("L3YxL3NlbmRTdGFnZUF1ZGl0RXZlbnQ="); },
  get CHECK_LEAD_ELIGIBILITY() { return d("L3YxL2NoZWNrTGVhZEVsaWdpYmlsaXR5"); },
  get GET_LEAD_REJECTION_LEVEL() { return d("L3YxL2dldExlYWRSZWplY3Rpb25MZXZlbA=="); },
  get INITIATE_BUREAU() { return d("L3YxL2luaXRpYXRlLWJ1cmVhdQ=="); },
  get AUTHENTICATE_DELIVERY_DATA() { return d("L3YxL2F1dGhlbnRpY2F0ZS1kZWxpdmVyeS1kYXRh"); },
  get BULK_UPLOAD() { return d("L3YxL2J1bGtVcGxvYWQ="); },
  get VIEW_DOC() { return d("L3YxL3ZpZXdEb2M="); },
  get GET_APPROVED_DOCS_BY_CATEGORY() { return d("L3YxL2dldEFwcHJvdmVkRG9jdW1lbnRzQnlDYXRlZ29yeQ=="); },
  get GET_JOURNEY_DOCS() { return d("L3YxL2dldEpvdXJuZXlEb2Nz"); },
  get DELETE_JOURNEY_DOC() { return d("L3YxL2RlbGV0ZUpvdXJuZXlEb2M="); },
  get UPLOAD_JOURNEY_DOC() { return d("L3YxL3VwbG9hZEpvdXJuZXlEb2M="); },
  get UPDATE_CURRENT_PAGE() { return d("L3YxL3VwZGF0ZUN1cnJlbnRQYWdl"); },
  get GET_ENTITY_DOCUMENT_MAPPINGS() { return d("L3YxL2dldEVudGl0eURvY3VtZW50TWFwcGluZ3M="); },
  get UDYAM_FETCH() { return d("L3YxL2RvY3VtZW50LWZldGNoL3VkeWFt"); },
};

// 3. OTP MS Backend Endpoints (REACT_APP_HT_OTP_MS)
export const OTP_MS_ENDPOINTS = {
  get CREATE_SESSION() { return d("L2NyZWF0ZS1zZXNzaW9u"); },
  get HISTORY() { return d("L2hpc3Rvcnk="); },
  get UPLOAD_STATUS() { return d("L3VwbG9hZC1zdGF0dXM="); },
  get ADD_OD_LIMIT() { return d("L2FkZC1vZC1saW1pdA=="); },
  get INITIATE_PROCESSING() { return d("L2luaXRpYXRlLXByb2Nlc3Npbmc="); },
  get UPLOAD_STATEMENT() { return d("L3VwbG9hZC1zdGF0ZW1lbnQ="); },
};
